module.exports = __webpack_public_path__ + "static/media/twogether.6676b317.png";